import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-brico-header',
  templateUrl: './brico-header.component.html',
  styleUrls: ['./brico-header.component.css']
})
export class BricoHeaderComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
